// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  min-height: 100vh;
  background: var(--background);
  padding: 16px;
}

.card {
  width: 100%;
  max-width: 600px;
  margin: auto;
  background: var(--background);
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.06);
  padding: 32px 18px;
}

.title {
  margin-bottom: 18px;
  color: var(--foreground);
  font-weight: 700;
  font-size: 1.5rem;
}

.loading, .noData {
  color: var(--muted-foreground);
}

.error {
  color: var(--danger);
}

.table {
  width: 100%;
  margin-top: 20px;
  border-collapse: collapse;
  font-size: 15px;
}

.tableHead {
  background: var(--muted);
}

.tableHeader {
  padding: 8px;
  color: var(--primary);
  font-weight: 600;
}

.tableRow {
  border-bottom: 1px solid var(--border);
}

.tableCell {
  padding: 8px;
}

@media (max-width: 480px) {
  .card {
    padding: 18px 8px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }
  .title {
    font-size: 1.1rem;
  }
  .tableHeader, .tableCell {
    font-size: 1rem;
    padding: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Payments.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;EACxC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":[".container {\n  min-height: 100vh;\n  background: var(--background);\n  padding: 16px;\n}\n\n.card {\n  width: 100%;\n  max-width: 600px;\n  margin: auto;\n  background: var(--background);\n  border-radius: 12px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.06);\n  padding: 32px 18px;\n}\n\n.title {\n  margin-bottom: 18px;\n  color: var(--foreground);\n  font-weight: 700;\n  font-size: 1.5rem;\n}\n\n.loading, .noData {\n  color: var(--muted-foreground);\n}\n\n.error {\n  color: var(--danger);\n}\n\n.table {\n  width: 100%;\n  margin-top: 20px;\n  border-collapse: collapse;\n  font-size: 15px;\n}\n\n.tableHead {\n  background: var(--muted);\n}\n\n.tableHeader {\n  padding: 8px;\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.tableRow {\n  border-bottom: 1px solid var(--border);\n}\n\n.tableCell {\n  padding: 8px;\n}\n\n@media (max-width: 480px) {\n  .card {\n    padding: 18px 8px;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  }\n  .title {\n    font-size: 1.1rem;\n  }\n  .tableHeader, .tableCell {\n    font-size: 1rem;\n    padding: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
